import React from 'react'

import ModalV4 from '../../../../app/ui/modal/v4/v4'
import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top"
import FieldManagementForm from "../../../fields3/render/management-form"
import {EntityType} from "../../../gd/const/item"
import FieldProto from "../../../fields3/proto/field-proto"
import {RequestForm_FieldTreatAs} from "../../../../app/tools/request-forms2/const/const";

type Props = {
    params: {
        entity              : EntityType
        field               : any
        disableRequired     : boolean
        autoSaveChanges?    : boolean

        // Request form parameters
        showTreatAs?        : boolean
        treatAs?            : RequestForm_FieldTreatAs

        onSubmit            : {(field: FieldProto, result:any):void}
    }
}

module.exports =  class ModalEditField extends ModalV4 {

    constructor(props: Props) {
        super(props)
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    _getTitle = () => {
        switch (this.props.params.entity) {
            case EntityType.FORM: return 'Edit form field'
            default             : return 'Edit custom field'
        }
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">{this._getTitle()}</div>

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <FieldManagementForm field              = {this.props.params.field}
                                     isNewField         = {false}
                                     disableRequired    = {this.props.params.disableRequired}
                                     autoSaveChanges    = {this.props.params.autoSaveChanges}
                                     showTreatAs        = {this.props.params.showTreatAs}
                                     treatAs            = {this.props.params.treatAs}
                                     entity             = {this.props.params.entity}
                                     onSubmit           = {this.props.params.onSubmit}/>
            </div>
        )
    }
}
